import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../config/axios";
import Loading from "components/Loading";
import { isEmpty } from "lodash";
import { useSnackbar } from "notistack";
import { Button, makeStyles } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Add, Edit as EditIcon } from "@material-ui/icons";
import { WarehouseAddOrEdit } from "./WarehouseAddOrEdit";
import IconButton from "@material-ui/core/IconButton";

import "./index.css";
import DeleteConfirmation from "components/DeleteConfirmation";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    flexGrow: 1
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  loading: {
    display: "flex",
    justifyContent: "center"
  }
}));

const WarehouseList = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [warehouses, setWarehouses] = useState([]);
  const [editWarehouse, setEditWarehouse] = useState(null);
  const [fetchingWarehouses, setFetchingWarehouses] = useState(false);
  const [isOpenWarehousePopup, setIsOpenWarehousePopup] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const fetchWarehouses = useCallback(() => {
    setFetchingWarehouses(true);
    axios
      .get(`/admin/warehouses`)
      .then(res => {
        setFetchingWarehouses(false);
        setWarehouses(res.data.data.warehouses);
      })
      .catch(error => {
        enqueueSnackbar(error, { variant: "error" });
      });
  }, [enqueueSnackbar]);

  useEffect(() => {
    if (isEmpty(warehouses)) {
      fetchWarehouses();
    }
  }, [warehouses, fetchWarehouses]);

  const onClickAddNewWarehouse = () => {
    setIsOpenWarehousePopup(true);
  };
  const handleCloseWarehousePopup = () => {
    setIsOpenWarehousePopup(false);
    setEditWarehouse(null);
    fetchWarehouses();
  };

  const handlDeleteWarehouse = warehouseId => {
    axios.delete(`/admin/remove-warehouse/${warehouseId}`).then(() => {
      enqueueSnackbar(t("warehouses.warehouseRemoved"), { variant: "success" });
      fetchWarehouses();
    });
  };

  const handleEditWarehouse = warehouse => {
    setIsOpenWarehousePopup(true);
    setEditWarehouse(warehouse);
  };

  return (
    <div className="warehouse-list">
      <WarehouseAddOrEdit isOpen={isOpenWarehousePopup} handleClose={handleCloseWarehousePopup} editWarehouse={editWarehouse} />
      {fetchingWarehouses && isEmpty(warehouses) ? (
        <div className={classes.loading}>
          <Loading />
        </div>
      ) : (
        <div>
          {warehouses && warehouses.length > 0 && (
            <div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                <Button startIcon={<Add />} color="primary" variant="contained" onClick={() => onClickAddNewWarehouse()}>
                  {t("warehouses.addNewWarehouse")}
                </Button>
              </div>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("warehouses.warehouseId")}</TableCell>
                      <TableCell>{t("warehouses.name")}</TableCell>
                      <TableCell>{t("warehouses.zipcode")}</TableCell>
                      <TableCell>{t("warehouses.latitude")}</TableCell>
                      <TableCell>{t("warehouses.longitude")}</TableCell>
                      <TableCell>{t("warehouses.adminEmails")}</TableCell>
                      <TableCell>{t("warehouses.active")}</TableCell>
                      <TableCell>{t("warehouses.actions")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {warehouses.map(warehouse => (
                      <TableRow key={warehouse._id}>
                        <TableCell> {warehouse._id}</TableCell>
                        <TableCell>{warehouse.name}</TableCell>
                        <TableCell>{warehouse.zipcode}</TableCell>
                        <TableCell>{warehouse.latitude}</TableCell>
                        <TableCell>{warehouse.longitude}</TableCell>
                        <TableCell>{warehouse.admin_emails.join(",")}</TableCell>
                        <TableCell>{warehouse.is_active ? "Yes" : "No"}</TableCell>
                        <TableCell>
                          <div style={{ display: "flex" }}>
                            <IconButton aria-label="expand row" size="small" onClick={() => handleEditWarehouse(warehouse)}>
                              <EditIcon />
                            </IconButton>
                            <DeleteConfirmation onConfirm={handlDeleteWarehouse} data={warehouse._id} />
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WarehouseList;
